module.exports = __webpack_public_path__ + "img/coding.6f6915bb.svg";